import Util from '../../../forecast-app/shared/util/util';
import { useDataExport } from "../../../forecast-app/shared/hooks/useDataExport";
import ProjectFormatter from "../../../forecast-app/shared/util/export-formatters/ProjectFormatter";
import { hasFeatureFlag } from "../../../forecast-app/shared/util/FeatureUtil";

export const FIXED_PRICE = 'fixed_price';
export const FIXED_PRICE_V2 = 'fixed_price_v2';
export const TIME_MATERIAL = 'time_material';
export const RETAINER = 'retainer';

const isFixedPrice = projectType => {
	return projectType === FIXED_PRICE || projectType === FIXED_PRICE_V2;
};

const getVisibleColumns = (theEyeOptions, projectType) => {
	let visibleColumns = [];

	theEyeOptions.forEach(option => {
		switch (option.name) {
			case 'project':
				visibleColumns.push('projectId');
				visibleColumns.push('projectName');
				break;
			case 'uninvoiced_time_registrations':
				if (projectType === TIME_MATERIAL) {
					visibleColumns.push('uninvoicedTimeRegistrationsTime');
					visibleColumns.push('uninvoicedTimeRegistrationsAmount');
				}
				break;
			case 'uninvoiced_fixed_price':
				if (isFixedPrice(projectType)) {
					visibleColumns.push('uninvoiced_fixed_price');
				}
				break;
			case 'uninvoiced_locked_periods':
				if (projectType === RETAINER) {
					visibleColumns.push('uninvoicedLockedPeriodsTime');
					visibleColumns.push('uninvoicedLockedPeriodsAmount');
				}
				break;
			case 'total_uninvoiced_time_material':
				if (projectType === TIME_MATERIAL) {
					visibleColumns.push('total_uninvoiced');
				}
				break;
			case 'total_uninvoiced_fixed_price':
				if (isFixedPrice(projectType)) {
					visibleColumns.push('total_uninvoiced');
				}
				break;
			case 'total_uninvoiced_retainer':
				if (projectType === RETAINER) {
					visibleColumns.push('total_uninvoiced');
				}
				break;
			default:
				visibleColumns.push(option.name);
		}
	});
	visibleColumns.push('currency');
	return visibleColumns;
};

// can be removed with new_csv_format feature flag
const getProjectCSVData = (project, visibleColumns, intl) => {
	let dataColumn = {};

	visibleColumns.forEach(column => {
		let value;

		switch (column) {
			case 'projectId':
				value = 'P' + project.companyProjectId;
				break;
			case 'projectName':
				value = project.name;
				break;
			case 'client':
				value = project.client ? project.client.name : '';
				break;
			case 'uninvoicedTimeRegistrationsTime':
			case 'uninvoicedLockedPeriodsTime':
				value = Util.convertMinutesToFullHour(project.uninvoicedMinutes, intl);
				break;
			case 'uninvoicedTimeRegistrationsAmount':
			case 'uninvoicedLockedPeriodsAmount':
				value = project.uninvoicedPrice;
				break;
			case 'uninvoiced_expenses':
				value = project.uninvoicedExpenses;
				break;
			case 'uninvoiced_fixed_price':
				value = project.uninvoicedFixedPrice;
				break;
			case 'total_uninvoiced':
				value = project.uninvoicedPrice + project.uninvoicedExpenses + project.uninvoicedFixedPrice;
				break;
			case 'total_invoiced':
				value = project.invoicedAmount;
				break;
			case 'currency':
				value = project.currency;
				break;
		}

		dataColumn[column] = value;
	});

	return dataColumn;
};

// can be removed with new_csv_format feature flag
const getCSVData = (projectData, visibleColumns, intl) => {
	let csvData = [];

	projectData.projects.forEach(project => {
		csvData.push(getProjectCSVData(project, visibleColumns, intl));
	});

	return csvData;
};

// can be removed with new_csv_format feature flag
const getHeader = visibleColumns => {
	return (
		visibleColumns.map(column =>
			column
				.split(/(?=[A-Z]|_)/)
				.map(word => word.replace('_', '').toLocaleLowerCase())
				.join(' ')
		) + '\r\n'
	);
};

// can be removed with new_csv_format feature flag
const exportFile = (visibleColumns, csvData, fileName) => {
	let exportData = getHeader(visibleColumns);
	exportData += Util.JSONToCSV(csvData);
	Util.exportToCSV(exportData, fileName);
};

function getFileName(projectType, timeMaterialDateRange) {
	let fileName = 'invoice_overview_' + projectType;
	if (projectType === TIME_MATERIAL) {
		fileName += '_' + timeMaterialDateRange.startDate.format('D-MMM-YYYY') + '_' + timeMaterialDateRange.endDate.format('D-MMM-YYYY');
	}
	return fileName;
}

export function exportType(projectType, data, intl, availableFeatureFlags) {

	if (hasFeatureFlag('new_csv_format', availableFeatureFlags)) {
		const exportData = useDataExport(
			new ProjectFormatter(intl, [], [], true),
			null,
			d => d,
			_ => getFileName(projectType, data.timeMaterialDateRange)
		);

		const visibleColumns =  getVisibleColumns(data.theEyeOptions, projectType).map(name => {
			return {
				name: name,
				checked: true
			}
		});

		exportData(
			visibleColumns,
			data.projectData[projectType].projects,
			null,
			null,
			'CSV'
		);
	} else {
		const visibleColumns = getVisibleColumns(data.theEyeOptions, projectType);
		const csvData = getCSVData(data.projectData[projectType], visibleColumns, intl);
		if (csvData.length > 0) {
			const fileName = getFileName(projectType, data.timeMaterialDateRange)+'.csv';
			exportFile(visibleColumns, csvData, fileName);
		}
	}
}

export const exportAllTypes = (data, intl, availableFeatureFlags) => {
	exportType(TIME_MATERIAL, data, intl, availableFeatureFlags);
	setTimeout(() => exportType(FIXED_PRICE, data, intl, availableFeatureFlags), 100);
	setTimeout(() => exportType(RETAINER, data, intl, availableFeatureFlags), 200);
};
